import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import { $orgInfo } from '@nx-frontend/shared/store/org-info';
import { $orgRole } from '@nx-frontend/shared/store/org-role';
import { $user } from '@nx-frontend/shared/store/user';
import { $workspaceAccess } from '@nx-frontend/shared/store/workspace-access';
import { webnotesThemeColors, webnotesThemeStyle } from '@nx-frontend/shared/themes/webnotes';
import { BucketFile, WorkspaceRole } from '@nx-frontend/shared/types';
import { useShowFileInfo } from './useShowFileInfo';

interface UseShowWebnotesFileInfoParams {
  file: BucketFile;
}

export const useShowWebnotesFileInfo = (): ((params: UseShowWebnotesFileInfoParams) => void) => {
  const showFileInfo = useShowFileInfo();

  const [orgRole, user, workspaceAccess, orgInfo] = useUnit([$orgRole, $user, $workspaceAccess, $orgInfo]);

  const canEdit = useMemo(
    () => [WorkspaceRole.EDITOR, WorkspaceRole.ADMIN].includes(workspaceAccess.role),
    [workspaceAccess.role]
  );

  return ({ file }: UseShowWebnotesFileInfoParams) => {
    showFileInfo({
      item: file,
      orgRole,
      userId: user.id,
      fileOpenHost: orgInfo.domain,
      themeColors: webnotesThemeColors,
      themeStyle: webnotesThemeStyle,
      openFileLocationEnabled: true,
      canEditOtherUsersFile: canEdit,
    });
  };
};
